































































import { Component, Model, Vue } from "vue-property-decorator";
import DfiDialog from "../DfiDialog/DfiDialog.vue";
import DfiFieldWrapper from "../DfiForm/DfiFieldWrapper.vue";
import VesselsClient from "Clients/vessels-client";
import vesselGroupsClient from "Clients/vessel-groups-client";
import { Vessel } from "@/types/vessel";
import SnackbarModule from "@/store/clients/Snackbar.module";
import { getModule } from "vuex-module-decorators";
import store from "@/store";
import VesselSelect from "./VesselSelect.vue";

const Snackbar = getModule(SnackbarModule, store);

@Component({
  components: {
    DfiDialog,
    DfiFieldWrapper,
    VesselSelect,
  },
})
export default class CreateVesselGroupDialog extends Vue {
  @Model("update:modelValue") isDialogVisible!: boolean;

  groupName: string = "";
  vessels: Vessel[] = [];
  vesselsList: Vessel[] = [];
  submitting: boolean = false;
  nameFilter: string = "";

  get isFormValid(): boolean {
    return this.groupName.trim() !== "" && this.vessels.length > 0;
  }

  get isVesselGroupPage(): boolean {
    return this.$route.name === "VesselGroups";
  }

  get icon(): string {
    if (this.vessels.length === this.filteredVessels.length) return "mdi-close-box";
    if (this.vessels.length > 0) return "mdi-minus-box";

    return "mdi-checkbox-blank-outline";
  }

  get filteredVessels(): Vessel[] {
    return this.vesselsList.filter(vessel =>
      vessel.name.toLowerCase().includes(this.nameFilter.toLowerCase())
    );
  }

  get noDataMessage(): string {
    return this.nameFilter && this.vesselsList.length > 0
      ? "No vessels found matching your search criteria"
      : "No vessels available";
  }

  async created() {
    this.vesselsList = await VesselsClient.getVessels(false);
  }

  onVisibilityChange(visible: boolean): void {
    this.$emit("update:modelValue", visible);
  }

  close(): void {
    this.$emit("update:modelValue", false);
  }

  toggle() {
    this.$nextTick(() => {
      if (this.vessels.length === this.filteredVessels.length) {
        this.vessels = [];
      } else {
        this.vessels = [...this.filteredVessels];
      }
    });
  }

  async createVesselGroup() {
    if (!this.isFormValid) return;

    this.submitting = true;

    try {
      const response = await vesselGroupsClient.create({ name: this.groupName });
      
      const vesselGroup = response;
      const addVessel = (vessel: Vessel) => vesselGroupsClient.addVesselToGroup(vessel, vesselGroup);

      await Promise.allSettled(this.vessels.map(addVessel));

      this.$emit("groupAdded");

      Snackbar.showSnackbar({
        text: `New vessel group was <b>created</b>`,
        color: "success",
      });
    } catch (error) {
      Snackbar.showSnackbar({ text: "Failed to create Vessel Group" });
    } finally {
      this.submitting = false;
    }
  }
}
